import * as actions from './redux/actions';
import reducer from './redux/reducer';
import SiteHeader, { Props } from './SiteHeader';

export { actions, reducer, type Props };
export default SiteHeader;
